import { ROLES, User } from "../components/Authentication";


export enum ActionAccess {
    ALLOWED,
    BY_REQUEST,
    NOT_ALLOWED
}


export class GatewayApi {
    endpoint: string;
    baseUrl: string;
    baseHeaders: Record<string, string>;
    user?: User;
    jwt?: string;

    constructor(endpoint: string) {
        const { REACT_APP_API_URL, REACT_APP_API_KEY } = process.env;
        this.endpoint = endpoint;
        this.baseUrl = `${REACT_APP_API_URL}/${endpoint}`;
        this.baseHeaders = {'x-api-key': REACT_APP_API_KEY || ""};
    }

    public setUser(user?: User) {
        this.user = user;
    }

    public setJwt(jwt?: string) {
        this.jwt = jwt;
    }

    getAccessLevel(action: string): ActionAccess {
        const { user } = this;
        if (!user)
            return ActionAccess.NOT_ALLOWED;

        const { roles, resources } = user;

        if (roles.includes(ROLES.SUPER_ADMIN) || resources['*']?.includes('any')) {
            return ActionAccess.ALLOWED;
        }

        const actions: string[] | undefined = resources[this.endpoint];
        if (!actions) {
            return ActionAccess.NOT_ALLOWED;
        }

        if (actions.find(a => a === 'any' || a === action)) {
            return ActionAccess.ALLOWED;
        }
        else if (actions.includes(`request_${action}`)) {
            return ActionAccess.BY_REQUEST;
        }

        return ActionAccess.NOT_ALLOWED;
    }

    public async invoke(action: string, body: object={}) {
        const accessLevel = this.getAccessLevel(action);
        const actionUrl = `${this.baseUrl}/${action}`;

        if (accessLevel === ActionAccess.NOT_ALLOWED) {
            console.error(`action ${actionUrl} is forbidden for user ${this.user}`);
            return null;
        }
        else if (accessLevel === ActionAccess.BY_REQUEST) {
            const result = await this.submit_request(`${this.endpoint}/${action}`, body);
            return {'request_submitted': result };
        }

        const response = await fetch(`${this.baseUrl}/${action}`, {
            method: 'POST',
            headers: {...this.baseHeaders, 'Authorization': this.jwt || ""},
            body: JSON.stringify(body)
        });

        const json = await response.json()
        if (json.error){
            console.error('Response error:', json.error);
            window.history.pushState({}, '', `/error?error=${json.error}`);
            window.dispatchEvent(new PopStateEvent('popstate'));
            return null;
        }
        return json;
    }

    protected async submit_request(actionUrl: string, body: object={}): Promise<boolean> {
        const { REACT_APP_API_URL: API_URL } = process.env;

        const response = await fetch(`${API_URL}/requests/submit`, {
            method: 'POST',
            headers: {...this.baseHeaders, 'Authorization': this.jwt || ""},
            body: JSON.stringify({
                submitted_by: this.user?.id,
                url: actionUrl,
                body: JSON.stringify(body)
            })
        });

        const json = await response.json() as { result?: boolean };
        return json.result ?? false;
    }
}
